<template>
  <div>
    <PreviewLayout :item="item" :loading="loading">
      <div class="p-postEditor__product">
        <div class="p-postEditor__product__main">
          <div class="p-postEditor__product__left">
            <div class="p-postEditor__product__figure">
              <div
                @click.stop
              >
                <template v-if="product.productImages !== undefined && product.productImages.length !== 0">
                <v-app class="carousel_product_introduction">
                  <v-carousel
                    hide-delimiters
                    class="carousel_product_introduction"
                  >
                    <v-carousel-item
                      v-for="(image, i) in product.productImages"
                      :key="i"
                    >
                      <img
                        class="product_introduction_image"
                        :src="
                          productImageSrc(image, 200, 200)
                        "
                      />
                    </v-carousel-item>
                  </v-carousel>
                  <div style="display: inline-block">
                    <img
                      v-for="(image, i) in product.productImages"
                      :key="i"
                      class="product_introduction_image_thumbs"
                      :src="productImageSrc(image, 200, 200)"
                    />
                  </div>
                </v-app>
                </template>
                <template v-else>
                  <img
                    class="product_introduction_image"
                    :src="
                      imageSrc('', 200, 200)
                    "
                  />
                </template>
              </div>
            </div>
          </div>
          <div class="p-postEditor__product__right">
            <!-- <p>{{ product.alternateName }}</p> -->
            <h3 class="p-postEditor__product__heading">
              {{ product.name }}
            </h3>
            <h4 v-if="product.price">
              <span class="p-postEditor__product__price"
                >{{ product.price }}円</span
              >
              （
              <span v-if="product.taxIncluded"> 税込 </span>
              <span v-else> 税抜 </span>
              ・参考価格）
            </h4>
            <v-btn
              v-for="link in product.productLinks"
              :key="link.id"
              :href="product.url"
              target="_blank"
              class="mt-2 mb-1 pa-2"
              small
              min-width="200"
              :style="linkStyle(link)"
            >
              {{ link.linkText }}
            </v-btn>
          </div>
        </div>
        <div class="p-postEditor__product__footer">
          <h4 class="p-postEditor__product__intro_heading"></h4>
          <p
            class="p-postEditor__product__introduction"
            style="white-space: pre-line"
            v-html="previewContent(product.description)"
          ></p>
        </div>
      </div>
    </PreviewLayout>
  </div>
</template>

<script>
import PreviewLayout from './PreviewLayout'
import baseTextlintPreview from '@/mixins/base_textlint_preview'
import imageUtilsMixin from '@/mixins/image_utils'

export default {
  name: 'SelectedProductIntroductionItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview, imageUtilsMixin],
  props: {
    item: {
      type: Object,
      required: true
    },
    product: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.setLintAction(this.product.description)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.product.description)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  },
  methods: {
    linkStyle (link) {
      return {
        'color': link.productLinkStyle.textColorCode,
        'background-color': link.productLinkStyle.backgroundColorCode
      }
    }
  }
}
</script>
<style scoped>
.carousel_product_introduction {
  width: 200px;
  height: 185px !important;
  max-height: 185px !important;
}

.product_introduction_image {
  height: 185px;
}

.product_introduction_image_thumbs {
  width: 35px;
  height: 30px;
  margin: 2px 0 2px 0;
  object-fit: contain;
}
</style>
